@if (!hide && visit) {
<mat-card class="visit-card">
  <mat-toolbar [ngClass]="{
    'completed-bar': visit.visitStatus === 'COMPLETED',
    'new-bar': visit.visitStatus === 'NEW' || visit.visitStatus === 'BOOKED' || visit.visitStatus === 'FLOATING',
    'referred-bar': visit.visitStatus === 'REFERRED',
    'cancelled-bar': visit.visitStatus === 'CANCELLED',
    'in_progress-bar': visit.visitStatus === 'IN_PROGRESS'
  }" class="toolbar-content">
    <b>
      {{ getStatusText(visit.visitStatus) }} {{ visit.visitType.description }}
    </b>
    <div class="toolbar-buttons">
      @if (isProject) {
      <div class="project-notice">Project Visit, Rebook via Orchestrator</div>
      }
      @if (allowAudit) {
      <button (click)="openVisitAudit()" mat-flat-button class="toolbar-button" aria-label="View visit history">
        <i class="fas fa-history"></i>
      </button>
      }
      @if (referVisit) {
      <button (click)="openReferralForm()" color="warn" mat-flat-button class="toolbar-button">
        Refer Visit
      </button>
      }
  @if (showBookAppointmentButton) {
      <button (click)="bookAppointment()" color="primary" mat-flat-button class="toolbar-button">Book
        Appointment
      </button>
      }
  @if (showRebookAppointmentButton) {
      <button (click)="rebookAppointment()" color="primary" mat-flat-button class="toolbar-button">
        Re-book
        Appointment
      </button>
      }
      @if (cancelVisit) {
      <button (click)="openCancelForm()" color="warn" mat-flat-button>No Longer Required
      </button>
      }
    </div>
  </mat-toolbar>
  <div class="main-content">
    <div class="time-section">
      <div class="time-container">
        <app-calendar-date-display [displayDate]="visit.appointmentStart"></app-calendar-date-display>

        @if (visit.visitStatus === 'FLOATING') {
        <!-- Floating booking display -->
        <div class="time-details floating-visit">
          <div class="floating-badge">
            <mat-icon fontIcon="fa-calendar-week" fontSet="far"></mat-icon>
            <span>Floating Booking</span>
          </div>
          <div class="date-range">
            <span class="days-arrow">←</span>
            <span class="days-count">{{ getDaysRange() }} days</span>
            <span class="days-arrow">→</span>
          </div>
        </div>
        <app-calendar-date-display [displayDate]="visit.appointmentEnd"></app-calendar-date-display>
        } @else {
        <!-- Normal appointment time display -->
        <div class="time-details">
          @if (visit.appointmentStart) {
          <div class="time-display">
            {{ visit.appointmentStart | amLocal | amDateFormat : 'h:mm A' }}
          </div>
          }
          <div>
            to
          </div>
          @if (visit.appointmentEnd) {
          <div class="time-display">
            {{ visit.appointmentEnd | amLocal | amDateFormat : 'h:mm A' }}
          </div>
          }
        </div>
        }
      </div>
    </div>
    <div class="tickets-section">
      <mat-list class="ticket-list">
        @for (ticket of visit.ticketList; track ticket) {
        <mat-list-item class="ticket-list-item">
          <app-ticket-expand
            [ticket]="ticket"
            [draft]="draft"
            (ticketClick)="openTicketDialog($event)">
          </app-ticket-expand>
        </mat-list-item>
        }
      </mat-list>
    </div>
    <div class="schedule-section">
      <mat-list>
        @for (schedule of visit.visitScheduleList; track schedule) {
        <mat-list-item class="ticket-list-item">
          <div class="schedule-container" [matTooltip]="schedule.sorDescription">
            <div class="schedule-details">
              <h4 mat-line class="schedule-title">{{ schedule.quantity }} x {{ schedule.sorDescription }}</h4>
              <p mat-line class="schedule-code">{{ schedule.sorCode }}</p>
            </div>
          </div>
        </mat-list-item>
        }
      </mat-list>
    </div>
  </div>
</mat-card>
}
